<template>
    <div class="details-container">
      <div class="details-header">
          <div class="details-header-left" @click="handleBack">
            <img src="/assets/~/media/images/ai/left-arrow-white-icon.png" alt="">
            <div>返回</div>
          </div>
          <div class="details-header-middle">
            {{ typeText }}
          </div>
          <div style="width: 36px"></div>
      </div> 
      <div class="details-grid-wrapper">
        <div
            v-for="(item, index) in currentPageData"
            :key="index"
            class="part-item"
            @click="openLink(item.url)"
        >
            <div class="item-title">{{ item.title }}</div>
            <div class="item-content">{{ item.description }}</div>
        </div>
        
        <!-- 分页控件 -->
        <div v-if="showPagination" class="pagination-container">
          <div class="pagination-info">
            共 {{ dataList.length }} 条记录，每页显示
            <el-select v-model="pageSize" @change="handlePageSizeChange" size="small" style="width: 80px; margin: 0 5px;">
              <el-option label="10" :value="10"></el-option>
              <el-option label="20" :value="20"></el-option>
              <el-option label="50" :value="50"></el-option>
            </el-select>
            条
          </div>
          <el-pagination
            :current-page="currentPage"
            :page-size="pageSize"
            :total="dataList.length"
            :page-sizes="[10, 20, 50]"
            layout="prev, pager, next"
            @current-change="handlePageChange"
            :disabled="loading"
            small
          />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'moreCard',
    props: {
      typeText: {
        type: String,
        default: '相关信息 '
      },
      dataList: {
        type: Array,
        default: () => []
      }
    },
    components: {},
    data() {
      return {
        currentPage: 1,
        pageSize: 10,
        loading: false,
      }
    },
    computed: {
      // 总页数
      totalPages() {
        return Math.ceil(this.dataList.length / this.pageSize);
      },
      // 当前页显示的数据
      currentPageData() {
        const start = (this.currentPage - 1) * this.pageSize;
        const end = start + this.pageSize;
        return this.dataList.slice(start, end);
      },
      // 是否显示分页
      showPagination() {
        return this.dataList.length > this.pageSize;
      },
    },
    mounted() {
      
    },
    watch: {
      dataList: {
        handler() {
          // 当数据变化时，重置到第一页
          this.currentPage = 1;
        },
        deep: true,
      },
    },
    methods: {
        handleBack() {
          _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '相关信息-更多-返回', 1]);
          stm_clicki("send",'event',window.location.href, "点击", '相关信息-更多-返回');
            this.$emit('back');
        },
        openLink(url) {          
          _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '相关信息-更多-跳转链接'+url, 1]);
          stm_clicki("send",'event',window.location.href, "点击", '相关信息-更多-跳转链接'+url); 
          if (!url) return;
          window.open(url, '_blank');
        },
        // 分页相关方法
        handlePageChange(page) {
          _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '相关信息-更多-分页 页数'+page, 1]);
          stm_clicki("send",'event',window.location.href, "点击", '相关信息-更多-分页 页数'+page); 
          this.currentPage = page;
        },
        handlePageSizeChange(size) {
          _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '相关信息-更多-分页 每页条数'+size, 1]);
          stm_clicki("send",'event',window.location.href, "点击", '相关信息-更多-分页 每页条数'+size)
          this.pageSize = size;
          this.currentPage = 1;
        },
    },
}
  </script>
  
  <style lang="scss" scoped>
  @import './detail-parts/style/part.css';
    .details-container {
      width: 100%;
      height: 100%;
      //   padding: calc(20 / 1080 * 100vh) calc(20 / 1920 * 100vw);
      background-color: rgba(6, 20, 31, 1);
    }
    
    
    
    .details-header {
        // height: calc(80 / 1920 * 100vw);
        height: 57px;
        display: flex;
        align-items: center; 
        justify-content: space-between;
        padding: 0 calc(35 / 1920 * 100vw);
        background-color: rgba(6, 20, 31, 1);
        .details-header-left {
            display: flex;
            align-items: center;
            // gap: calc(10 / 1920 * 100vw);
            gap: 5px;
            cursor: pointer;
            img {
                // width: calc(20 / 1920 * 100vw);
                // height: calc(20 / 1920 * 100vw);
                width: 18px;
                height: 18px;
            }
            div {
                font-size: 13px;
                color: #fff;
                font-family: 'FZLanTingHeiS-R-GB'; 
                line-height: 1;
            }
        }
        .details-header-middle {
            // font-size: calc(22 / 1920 * 100vw);
            font-size: 15px;
            color: #fff;
            font-family: 'FZLanTingHeiS-B-GB'; 
            line-height: 1;
        }
   }
    .details-grid-wrapper {
        padding: calc(30 / 1920 * 100vw) calc(30 / 1920 * 100vw);
        border-radius: calc(12 / 1920 * 100vw) calc(12 / 1920 * 100vw) 0 0;
        overflow: auto;
        background-color: #fff;
        // height: calc(100% -  80 / 1920 * 100vw);
        height: calc(100% -  57px);
         
        /* 自定义滚动条样式 */
        &::-webkit-scrollbar { 
        width: 4px;
        }
        
        &::-webkit-scrollbar-track {
        background: rgba(0, 0, 0, 0.05);
        border-radius: 3px;
        }
        
        &::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.2);
        border-radius: 3px; 
        transition: background 0.3s ease;
        
        &:hover {
            background: rgba(0, 0, 0, 0.4);
        }
        }
        
        /* Firefox 滚动条样式 */
        scrollbar-width: thin;
        scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);

        .part-item {
            padding: calc(20 / 1920 * 100vw) calc(20 / 1920 * 100vw);
            border-radius: calc(8 / 1920 * 100vw);
            cursor: pointer;
            transition: background-color 0.2s ease;
        }
        .part-item:hover {
            background-color: rgba(225, 229, 234, 0.5);
        }
        
        // 分页控件样式
        .pagination-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 20px;
          padding-top: 20px;
          border-top: 1px solid #e5e5e5;
          
          .pagination-info {
            font-size: 14px;
            color: #666;
            display: flex;
            align-items: center;
          }
          
          .el-pagination {
            .el-pager li {
              min-width: 28px;
              height: 28px;
              line-height: 28px;
              font-size: 12px;
            }
            
            .btn-prev, .btn-next {
              width: 28px;
              height: 28px;
              line-height: 28px;
              font-size: 12px;
            }
          }
        }
   }
   
   
  </style>
  